// 어카운트 status를 localStorage로 보관 — 0 승인대기 / 1 생성완료 / 6 생성중 / 9 정지 / 99 조회실패
// 1(생성완료)일 때만 보호 페이지 접근 허용 (SvrGuard에서 사용)
const ACCOUNT_STATUS_KEY = 'accountStatus'

export const ACCOUNT_STATUS_ACTIVE = 1

export const setAccountStatus = (status: number | undefined) => {
  if (status === undefined) {
    localStorage.removeItem(ACCOUNT_STATUS_KEY)
    return
  }
  localStorage.setItem(ACCOUNT_STATUS_KEY, String(status))
}

export const getAccountStatus = (): number | null => {
  const raw = localStorage.getItem(ACCOUNT_STATUS_KEY)
  return raw === null ? null : Number(raw)
}

export const clearAccountStatus = () => {
  localStorage.removeItem(ACCOUNT_STATUS_KEY)
}
